module.exports = __webpack_public_path__ + "img/previous-arrow.1be21430.svg";